import React, { useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { SFHotelUsuarioCheckoutDo } from "services/services-mia/SFHotelUsuarioCheckoutDo";

export default function CheckoutUsuarioModal({
    reserva,
    updateList,
    closeModal,
    setterRowSelected,
}) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleCheckout = async () => {
        const SFHabitacionHuespedId = reserva?.SFHabitacionHuespedId ?? reserva?.id;
        if (!SFHabitacionHuespedId) return;
        setInRequest(true);
        const response = await SFHotelUsuarioCheckoutDo(credentials, {
            SFHabitacionHuespedId,
        });
        setInRequest(false);
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Checkout realizado correctamente",
                severity: "success",
                open: true,
            });
            updateList();
            setterRowSelected({ status: false, row: {} });
            closeModal();
        }
    };

    const huesped = [reserva?.usuarioApellidos, reserva?.usuarioNombres]
        .filter(Boolean)
        .join(", ");

    return (
        <div className={styles.inputs}>
            <div className={styles.column}>
                <p style={{ margin: 0 }}>
                    ¿Confirmás realizar el checkout de{" "}
                    {huesped ? `${huesped}` : "este huésped"} de la habitación{" "}
                    {reserva?.habitacionNumero ?? "-"}?
                </p>
                <FormButton
                    inRequest={inRequest}
                    newFormData={{ button: "Realizar checkout" }}
                    onClick={handleCheckout}
                    onCloseModal={closeModal}
                    ignoreSnackbar
                />
                {inRequest && <CircularIndeterminate />}
            </div>
        </div>
    );
}
